import React, { useEffect, useRef, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import { TaxClass } from "../../../core/json/TaxClass";
import {
  PromoProductsClass,
  toPromoProductRef,
} from "../../../core/json/PromoProductsClass";
import toast from "react-hot-toast";
import { editPromoProduct } from "../../../services/MasterApiServices";

const EditPromoProduct = ({ data, Promotionlist, handlePromoProductList }) => {
  const { register, handleSubmit, setValue, getValues, watch, reset, control } =
    useForm({
      mode: "onChange",
      reValidateMode: "onChange",
    });
  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "promoProductDetail",
  });
  const [Data, setData] = useState([]);

  const { sectionList, productList, taxList } = useSelector(
    (state) => state.usersetting
  );
  const { userId } = useSelector((state) => state.userauth);
  const { branch } = useSelector((state) => state.branchlist);

  function resetmodal() {
    if (data) {
      setValue("promotion", data?.promotion?.guid ?? "");
      // replace() re-seeds the row list itself; setValue on a field-array
      // name does not reliably rebuild `fields` when another row is opened
      replace(
        (data?.promoProductsDetail || []).map((obj) => ({
          product: obj?.product?.guid ?? "",
          rate: obj?.price ?? "",
        }))
      ); // Populate form with data for editing
    } else {
      reset();
    }
  }

  useEffect(() => {
    resetmodal();
  }, [data, setValue]);

  const handleAddPromo = () => {
    append({ product: "", rate: "" });
  };
  const handleUpdatePromoProduct = async (formData) => {
    if (!formData?.promotion) {
      toast.error("Promotion name is required.");
      return;
    }
    const objtax = new TaxClass();
    const ProductDetail = (formData?.promoProductDetail || [])
      .filter((e) => e?.product)
      .map((e) => {
        const product = productList?.find((item) => item.guid == e.product);
        // keep the saved detail row's identity and tax when it is still there
        const saved = data?.promoProductsDetail?.find(
          (d) => d?.product?.guid == e.product
        );
        return {
          ...(saved ? { id: saved.id, guid: saved.guid } : {}),
          // a slim reference: the list row's flat fields fail model binding
          product: toPromoProductRef(product),
          price: Number(e.rate) || 0,
          tax:
            saved?.tax ||
            taxList?.find((t) => t.guid == product?.taxID) ||
            objtax,
        };
      });
    const objpromoproduct = new PromoProductsClass();
    const promotion = Promotionlist?.find(
      (item) => item.guid == formData.promotion
    );
    // as on Add: GetAll returns promotions with branch: null
    objpromoproduct.promotion = promotion && {
      ...promotion,
      branch: promotion.branch || branch,
    };
    objpromoproduct.branch = branch;
    objpromoproduct.guid = data.guid;
    objpromoproduct.id = data.id;
    objpromoproduct.createdUser = data.createdUser || `{${userId?.id}}`;
    objpromoproduct.createdDate = data.createdDate || objpromoproduct.createdDate;
    // Section is no longer part of a promo product (see PromoProductsClass);
    // this page never loads the section list, so the old lookup was always
    // undefined anyway.
    objpromoproduct.promoProductsDetail = ProductDetail;
    objpromoproduct.updatedUser = `{${userId?.id}}`;
    try {
      const response = await editPromoProduct(objpromoproduct);
      if (response?.data === false) {
        toast.error("Failed to update promo product.");
        return;
      }
      closemodal();
      handlePromoProductList();
      toast.success("Promo product updated successfully!");
    } catch (error) {
      toast.error(
        error?.response?.data?.Message ||
          error?.response?.data?.title ||
          "Failed to update promo product."
      );
      console.error(error);
    }
  };
  const closeButtonRef = useRef();

  const closemodal = () => {
    if (closeButtonRef.current) {
      closeButtonRef.current.click();
    }
  };
  return (
    <div>
      <div className="modal fade" id="edit-promo-product">
        <div className="modal-dialog  modal-dialog-centered">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Edit Promo Products</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    ref={closeButtonRef}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form onSubmit={handleSubmit(handleUpdatePromoProduct)}>
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="input-blocks">
                          <label>Promotion name</label>
                          {/* <Select
                            options={productlist}
                            classNamePrefix="react-select"
                            placeholder="Choose"
                          /> */}
                          <select
                            className="form-control"
                            {...register("promotion")}
                          >
                            <option value="">--select--</option>
                            {Promotionlist?.map((e, i) => {
                              return (
                                <option value={e.guid} key={i}>
                                  {e.name}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                      {/* Section removed, as on Add Promo Products: promo
                          products no longer carry a section and this page
                          never loads the section list (the select was empty). */}
                    </div>

                    <div className="row">
                      <div className="col-4">Product</div>
                      <div className="col-4">Rate</div>
                      <div className="col-4">Action</div>
                    </div>
                    {fields.map((obj, index) => {
                      return (
                        <React.Fragment key={obj.id}>
                          <hr />
                          <div className="row">
                            <div className="col-4">
                              <div className="input-blocks">
                                <select
                                  className="form-control"
                                  {...register(
                                    `promoProductDetail[${index}].product`
                                  )}
                                >
                                  <option value="">--select--</option>
                                  {productList?.map((e, i) => {
                                    return (
                                      <option value={e.guid} key={i}>
                                        {e.name}
                                      </option>
                                    );
                                  })}
                                </select>
                              </div>
                            </div>
                            <div className="col-4">
                              <div className="input-blocks">
                                <input
                                  type="text"
                                  className="form-control"
                                  {...register(
                                    `promoProductDetail[${index}].rate`
                                  )}
                                />
                              </div>
                            </div>

                            <div className="col-4">
                              <div className="edit-delete-action">
                                <Link
                                  className="confirm-text p-2"
                                  to="#"
                                  // onClick={() => handleDelete(index)}
                                  onClick={() => remove(index)}
                                >
                                  <i
                                    data-feather="trash-2"
                                    className="feather-trash-2"
                                  ></i>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </React.Fragment>
                      );
                    })}

                    <button
                      className="btn btn-success mt-4"
                      onClick={handleAddPromo}
                      type="button"
                    >
                      Add
                    </button>
                    <div className="col-lg-12">
                      <div className="modal-footer-btn">
                        <button
                          type="button"
                          className="btn btn-cancel me-2"
                          data-bs-dismiss="modal"
                        >
                          Reset
                        </button>
                        <button type="submit" to="#" className="btn btn-submit">
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Purchase */}
    </div>
  );
};

export default EditPromoProduct;
